<template>
  <div id="main-content">
    <div style="display: flex;background: #FFFFFF;padding: 10px;cursor: pointer">
      <div class="my-group">
        <div class="my-group-item my-group-item-left" :class="type==='add'?'active':''" @click="type='add'">新增</div>
        <div class="my-group-item " :class="type==='user'?'active':''" @click="type='user'">活跃</div>
        <div class="my-group-item" :class="type==='retention'?'active':''" @click="type='retention'">留存</div>
        <div class="my-group-item my-group-item-right" :class="type==='times'?'active':''"  @click="type='times'">会话</div>
      </div>
      <div style="margin-left: 5px;">
        <a-range-picker v-model="date"
                        valueFormat="YYYY-MM-DD"
                        style="width: 240px;" @change="init_list"/>
      </div>
    </div>
    <div class="gb-table-panel" style="margin-top: 10px;background: #FFFFFF;">
      <div class="gb-table-content" >
        <div class="gb-table-list" style="background: #E5E5E5;position: absolute;top:0px;">
          <div class="gb-table-item" style="width: 400px;">产品</div>
          <div class="gb-table-item" >DataFinder</div>
          <div class="gb-table-item" >Adjust</div>
          <div class="gb-table-item" v-if="type==='add'">渠道平台</div>
        </div>
        <a-spin v-if="dataLoading" style="width: 100%;margin-top: 20px;"></a-spin>
        <div v-else class="gb-table-list" v-for="(dataItem,dataIndex) in  dataList">
          <div class="gb-table-item" style="width: 400px;">
            {{dataItem.app_name}}
          </div>
          <div class="gb-table-item" >
            {{dataItem.data_finder}}
          </div>
          <div class="gb-table-item" >
            {{dataItem.adjust}}
          </div>
          <div class="gb-table-item" v-if="type==='add'">
            {{dataItem.base}}
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {GetProductCheck} from "../../../api/v1/product_api";

export default {
  name: "Index",
  data(){
    return {
      type:'add',
      date:['',''],
      dataLoading:false,
      dataList:[],
    }
  },
  watch:{
    type:{
      handler:function (value,oldVal){
        this.init_list()
      }
    },
  },
  mounted() {
    this.init_list()
  },
  methods:{
    init_list(){
      this.dataLoading = true
      GetProductCheck({type:this.type,start:this.date[0],end:this.date[1]}).then(resp => {
        if (resp.code===200){
          this.dataLoading = false
          this.dataList = Object.values(resp.data.list).filter(item=>{
            return item.adjust!=undefined||item.data_finder!=undefined||item.base!=undefined
          })
          this.date = resp.data.date
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Product/Check/Index.vue